<template>
  <div name="stdreq-detail" id="stdreq-detail">
    <div class="detail detail-responsive">
      <div class="clearfix detail-row">
        <div class="detail-left label-left" style="font-size: 16px; font-weight: 700; margin-bottom: 3px;">{{ labels['STD_REQP1']['20'] }}</div>
        <div class="detail-right" style="margin-bottom:10px;">
            <div class="detail-text width-70">{{ data['treqest1'].numreqst }}</div>
        </div>
      </div>
    </div>
    <div id="stdreq-detail-accordion">
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#stdreq-detail-accordion" href="#stdreq-detail-treqest1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['STD_REQP1']['30'] }}
          </h3>
        </div>
        <div id="stdreq-detail-treqest1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['STD_REQP1']['40'] }}</label>
                  <div class="form-control readonly-field-color">{{ data['treqest1'].desc_codcomp }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['STD_REQP1']['50'] }}</label>
                  <div class="form-control readonly-field-color">{{ data['treqest1'].codemprq }} - {{ data['treqest1'].desc_codemprq }}</div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>{{ labels['STD_REQP1']['90'] }}</label>
                  <div class="form-control readonly-field-color">{{ setDateOutput(data['treqest1'].dtereq) }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['STD_REQP1']['60'] }}</label>
                  <div class="form-control readonly-field-color">{{ data['treqest1'].codempap }} - {{ data['treqest1'].desc_codempap }}</div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>{{ labels['STD_REQP1']['100'] }}</label>
                  <div class="form-control readonly-field-color">{{ setDateOutput(data['treqest1'].dteaprov) }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['STD_REQP1']['70'] }}</label>
                  <div class="form-control readonly-field-color">{{ data['treqest1'].codemprc }} - {{ data['treqest1'].desc_codemprc }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ labels['STD_REQP1']['80'] }}</label>
                  <div class="form-control readonly-field-color">{{ data['treqest1'].desc_codpos }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8 col-md-offset-2">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{ labels['STD_REQP1']['120'] }}</label>
                      <div class="form-control readonly-field-color">{{ data['treqest1'].desc_stareq }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['STD_REQP1']['130'] }}</label>
                  <div class="input-group">
                    <input :value="data['treqest1'].totreq"
                           class="form-control text-center"
                           readonly />
                    <span class="input-group-addon disabled-icon">
                      {{ labels['STD_REQP1']['140'] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>{{ labels['STD_REQP1']['150'] }}</label>
                  <div class="input-group">
                    <input :value="data['treqest1'].totqtyact"
                           class="form-control text-center"
                           readonly />
                    <span class="input-group-addon disabled-icon">
                      {{ labels['STD_REQP1']['160'] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>{{ labels['STD_REQP1']['170'] }}</label>
                  <div class="input-group">
                    <input :value="data['treqest1'].toava"
                           class="form-control text-center"
                           readonly />
                    <span class="input-group-addon disabled-icon">
                      {{ labels['STD_REQP1']['180'] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8 col-md-offset-2">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>{{ labels['STD_REQP1']['110'] }}</label>
                      <textarea class="form-control"
                                :value="data['treqest1'].desnote"
                                readonly />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#stdreq-detail-accordion" href="#stdreq-detail-treqest2">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['STD_REQP2']['10'] }}
          </h3>
        </div>
        <div id="stdreq-detail-treqest2" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['STD_REQP1']['20'] }}</label>
                  <hrms-dropdown  v-model="codpos"
                                  :options="codposDropdown"
                                  :showNone="false" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['STD_REQP2']['30'] }}</label>
                  <div class="form-control readonly-field-color">{{ detailTreqest2.codjob }} - {{ detailTreqest2.desc_codjob }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ labels['STD_REQP2']['40'] }}</label>
                  <div class="form-control readonly-field-color">{{ detailTreqest2.codempmt }} - {{ detailTreqest2.desc_codempmt }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['STD_REQP2']['50'] }}</label>
                  <div class="input-group">
                    <input :value="detailTreqest2.qtydatrqyr"
                           class="form-control text-center"
                           readonly />
                    <span class="input-group-addon disabled-icon">
                      {{ labels['STD_REQP2']['60'] }}
                    </span>
                    <input :value="detailTreqest2.qtydatrqmh"
                           class="form-control text-center"
                           readonly />
                    <span class="input-group-addon disabled-icon">
                      {{ labels['STD_REQP2']['70'] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['STD_REQP2']['110'] }}</label>
                  <div class="input-group">
                    <input :value="detailTreqest2.qtyreq"
                           class="form-control text-center"
                           readonly />
                    <span class="input-group-addon disabled-icon">
                      {{ labels['STD_REQP2']['120'] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>{{ labels['STD_REQP2']['130'] }}</label>
                  <div class="input-group">
                    <input :value="detailTreqest2.qtyact"
                           class="form-control text-center"
                           readonly />
                    <span class="input-group-addon disabled-icon">
                      {{ labels['STD_REQP2']['140'] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>{{ labels['STD_REQP2']['150'] }}</label>
                  <div class="input-group">
                    <input :value="detailTreqest2.qtyava"
                           class="form-control text-center"
                           readonly />
                    <span class="input-group-addon disabled-icon">
                      {{ labels['STD_REQP2']['160'] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['STD_REQP2']['80'] }}</label>
                  <div class="form-control readonly-field-color">{{ detailTreqest2.amtincom }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ labels['STD_REQP2']['170'] }}</label>
                  <div class="form-control readonly-field-color">{{ detailTreqest2.desnoffi }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['STD_REQP2']['90'] }}</label>
                  <div class="form-control readonly-field-color">{{ setDateOutput(detailTreqest2.dtereqm) }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ labels['STD_REQP2']['230'] }}</label>
                  <div class="form-control readonly-field-color">{{ detailTreqest2.desc_codrearq }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['STD_REQP2']['100'] }}</label>
                  <div class="form-control readonly-field-color">{{ setDateOutput(detailTreqest2.dteopen) }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ labels['STD_REQP2']['210'] }}</label>
                  <div class="form-control readonly-field-color">{{ setDateOutput(detailTreqest2.dteclose) }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['STD_REQP2']['180'] }}</label>
                  <div class="radio">
                    <label class="radio-inline">
                        <input type="radio" value="I" :checked="detailTreqest2.flgrecut === 'I' ? true : false" disabled>
                        {{ labels['STD_REQP2']['190'] }}
                    </label>
                    <label class="radio-inline">
                        <input type="radio" value="E" :checked="detailTreqest2.flgrecut === 'E' ? true : false" disabled>
                        {{ labels['STD_REQP2']['200'] }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['STD_REQP2']['220'] }}</label>
                  <div class="checkbox">
                    <label class="checkbox-inline">
                        <input type="checkbox" value="Y" :checked="detailTreqest2.flgjob === 'Y' ? true : false" disabled>
                        {{ labels['STD_REQP2']['240'] }}
                    </label>
                  </div>
                  <div class="checkbox">
                    <label class="checkbox-inline">
                        <input type="checkbox" value="Y" :checked="detailTreqest2.flgcond === 'Y' ? true : false" disabled>
                        {{ labels['STD_REQP2']['250'] }}
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <textarea class="form-control"
                            :value="detailTreqest2.desc_syncond"
                            readonly />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8 col-md-offset-2">
                <div class="form-group">
                  <label>{{ labels['STD_REQP2']['260'] }}</label>
                  <textarea class="form-control"
                            :value="detailTreqest2.desnote"
                            readonly />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#stdreq-detail-accordion" href="#stdreq-detail-detail">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['STD_REQP3']['10'] }}
          </h3>
        </div>
        <div id="stdreq-detail-detail" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <hrms-table :columns="columns" :data="data['detail']" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'stdreq-detail',
  data () {
    return {
      codpos: ''
    }
  },
  computed: {
    codposDropdown () {
      let index = 0
      let dropdown = {}
      this.data.treqest2.rows.map((row, key) => {
        if (index === 0) {
          this.codpos = row.codpos
        }
        index += 1
        dropdown[row.codpos] = row.codpos + ' - ' + row.desc_codpos
        return row
      })
      return dropdown
    },
    detailTreqest2 () {
      if (this.data.treqest2.rows.length <= 0) {
        return {
          codjob: '',
          desc_codjob: '',
          codempmt: '',
          desc_codempmt: '',
          qtydatrqyr: '',
          qtydatrqmh: '',
          qtyreq: '',
          qtyact: '',
          qtyava: '',
          amtincom: '',
          desnoffi: '',
          dtereqm: '',
          desc_codrearq: '',
          dteopen: '',
          dteclose: '',
          flgrecut: '',
          flgjob: '',
          desc_syncond: '',
          desnote: ''
        }
      }
      return this.data.treqest2.rows.filter((row) => {
        return row.codpos === this.codpos
      }).pop()
    }
  },
  props: [ 'labels', 'data', 'columns' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// stdreqDetail.vue?81d6a6b6